const normalizeValue = (value: string): string => value.trim().toLowerCase();

export function resolveLanguageCodeFromParam(
  value: string | null | undefined,
  languages: Record<string, string>
): string | null {
  if (!value) {
    return null;
  }

  const normalizedInput = normalizeValue(value);

  if (!normalizedInput) {
    return null;
  }

  for (const code of Object.values(languages)) {
    if (normalizeValue(code) === normalizedInput) {
      return code;
    }
  }

  for (const [name, code] of Object.entries(languages)) {
    if (normalizeValue(name) === normalizedInput) {
      return code;
    }
  }

  return null;
}

export function resolveLanguageNameFromParam(
  value: string | null | undefined,
  languages: Record<string, string>
): string | null {
  if (!value) return null;

  const normalizedInput = normalizeValue(value);
  if (!normalizedInput) return null;

  const resolvedCode = resolveLanguageCodeFromParam(value, languages);
  if (resolvedCode) {
    return (
      Object.entries(languages).find(
        ([, code]) => normalizeValue(code) === normalizeValue(resolvedCode)
      )?.[0] || null
    );
  }

  return (
    Object.keys(languages).find((name) =>
      normalizeValue(name).startsWith(`${normalizedInput} (`)
    ) || null
  );
}
